import { render } from "./DashboardNavLeft.vue?vue&type=template&id=1b055cae&scoped=true&ts=true&lang=pug"
import script from "./DashboardNavLeft.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardNavLeft.vue?vue&type=script&lang=ts&setup=true"

import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css?vue&type=style&index=0&lang=css"
import "./DashboardNavLeft.vue?vue&type=style&index=1&id=1b055cae&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b055cae"]])

export default __exports__